import React, { useEffect } from "react";
import "./Carrer_Support_Team.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { useDispatch, useSelector } from "react-redux";
import { AllPlacementTeam } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Carrer_Support_Team = () => {
  // const teamData = [
  //   {
  //     id: 1,
  //     name: "Pratiksha Pethe",
  //     role: "Placement Manager",
  //     image: "/assets/images/pst_it_solution/placement_team_section/img-1.png",
  //   },
  //   {
  //     id: 2,
  //     name: "Paresh Markad",
  //     role: "Corporate Relations Manager",
  //     image: "/assets/images/pst_it_solution/placement_team_section/img-2.png",
  //   },
  //   {
  //     id: 3,
  //     name: "Pratiksha Pethe",
  //     role: "Product Associate",
  //     image: "/assets/images/pst_it_solution/placement_team_section/img-1.png",
  //   },
  //   {
  //     id: 4,
  //     name: "Paresh Markad",
  //     role: "Tech Interview Specialist",
  //     image: "/assets/images/pst_it_solution/placement_team_section/img-2.png",
  //   },
  //   {
  //     id: 5,
  //     name: "Paresh Markad",
  //     role: "Tech Interview Specialist",
  //     image: "/assets/images/pst_it_solution/placement_team_section/img-2.png",
  //   },
  // ];

  const dispatch = useDispatch();
  const placement_team = useSelector(
    (state) => state.common.all_placement_Team,
  );

  useEffect(() => {
    dispatch(AllPlacementTeam());
  }, [dispatch]);

  return (
    <section className="Carrer_Support_Team">
      <div className="container">
        <div className="Carrer_Support_Team_header">
          <h5>
            {" "}
            Placement & <span>Career Support Team</span>{" "}
          </h5>
        </div>

        <div className="placement_team_section">
          <Swiper
            slidesPerView={4}
            spaceBetween={25}
            // pagination={{ clickable: true }}
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop
            breakpoints={{
              0: { slidesPerView: 1.2 },
              420: { slidesPerView: 2 },
              576: { slidesPerView: 2.2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="team_swiper"
          >
            {placement_team.map((member, index) => (
              <SwiperSlide key={index}>
                <div className="team_card">
                  <div className="team_image_wrapper">
                    <img
                      src={`${IDS.IMG_URL}${member.image}`}
                      alt={member.name}
                      className="team_image"
                    />
                  </div>

                  <div className="team_content">
                    <h5 className="team_name">{member.name}</h5>
                    <p className="team_role">{member.designation}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Carrer_Support_Team;
